// @ts-nocheck

import DateFnsUtils from '@date-io/date-fns'
import { Grid, MenuItem, Tooltip } from '@material-ui/core'
import Box from '@material-ui/core/Box'
import InputAdornment from '@material-ui/core/InputAdornment'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import { visuallyHidden } from '@mui/utils'
import { ErrorMessage, Field } from 'formik'
import moment from 'moment'
import PropTypes from 'prop-types'
import React from 'react'
import { Calendar, HelpCircle } from 'react-feather'
import { useTranslation } from 'react-i18next'

import { DATEFORMATPLACEHOLDER } from '../../../helpers/constants'
import { isEmpty, noop } from '../../../helpers/utils'
import PhoneInput334 from '../../common/PhoneInput334'
import useStyles from '../Auth.Style'

function PersonalInfoForm({
  masterData,
  values,
  setFieldValue,
  birthDateVerification,
  schooolCountries,
  states,
  birthDateErr,
  setBirthDateErr,
  guestCheckout,
  metadata,
}) {
  const classes = useStyles()
  const { t } = useTranslation()

  return (
    <>
      <Grid item xs={12} sm={6}>
        <Box>
          <Typography component="p" variant="body2" color="textPrimary" gutterBottom>
            <Box component="span" fontWeight="500">
              {t('fields:firstName')}
            </Box>
            <Box component="span" className="mandatory">
              {t('fields:mandatory')}
            </Box>
          </Typography>
          <Field
            className="custom-input-field"
            name="first_name"
            as={TextField}
            fullWidth
            id="first_name"
            autoComplete="off"
            variant="outlined"
            size="small"
            pl={0}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Tooltip title={t('fields:firstNameHelp')} placement="top">
                    <HelpCircle className="help-icon" />
                  </Tooltip>
                </InputAdornment>
              ),
            }}
          />
          <ErrorMessage name="first_name">
            {(msg) => <span className="error">{t(msg, { field: t('fields:firstName') })}</span>}
          </ErrorMessage>
        </Box>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Box>
          <Typography component="p" variant="body2" color="textPrimary" gutterBottom>
            <Box component="span" fontWeight="500">
              {t('fields:lastName')}
            </Box>
            <Box component="span" className="mandatory">
              {t('fields:mandatory')}
            </Box>
          </Typography>
          <Field
            className="custom-input-field"
            name="last_name"
            as={TextField}
            variant="outlined"
            fullWidth
            size="small"
            id="last_name"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Tooltip title={t('fields:lastNameHelp')} placement="top">
                    <HelpCircle className="help-icon" />
                  </Tooltip>
                </InputAdornment>
              ),
            }}
          />
          <ErrorMessage name="last_name">
            {(msg) => <span className="error">{t(msg, { field: t('fields:lastName') })}</span>}
          </ErrorMessage>
        </Box>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Box className="custom-picker">
          <Typography component="p" variant="body2" color="textPrimary" gutterBottom>
            <Box component="span" fontWeight="500">
              {t('fields:dateOfBirth')}
            </Box>
            <Box component="span" className="mandatory">
              {t('fields:mandatory')}
            </Box>
          </Typography>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              className="custom-input-field"
              disableFuture
              autoOk
              variant="inline"
              fullWidth
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Tooltip title={t('fields:helpIconDateOfBirth')} placement="top">
                      <HelpCircle />
                    </Tooltip>
                  </InputAdornment>
                ),
              }}
              inputVariant="outlined"
              keyboardIcon={<Calendar />}
              size="small"
              format="MM/dd/yyyy"
              placeholder={DATEFORMATPLACEHOLDER}
              InputLabelProps={{ shrink: true }}
              id="dob"
              name="dob"
              maxDate={moment().subtract(6, 'years')}
              value={values.dob || null}
              onChange={(date) => {
                setFieldValue('dob', date)
                birthDateVerification(date, setFieldValue)
              }}
              onError={(err) => {
                if (err && !birthDateErr) {
                  setBirthDateErr(err)
                }
                if (!err && birthDateErr) {
                  setBirthDateErr('')
                }
              }}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
            />
          </MuiPickersUtilsProvider>
          <ErrorMessage name="dob">
            {(msg) => <span className="error">{t(msg, { field: t('fields:dateOfBirth') })}</span>}
          </ErrorMessage>
        </Box>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Box>
          <Typography component="p" variant="body2" color="textPrimary" gutterBottom>
            <Box component="span" fontWeight="500">
              {t('fields:emailAddress')}
            </Box>
            <Box component="span" className="mandatory">
              {t('fields:mandatory')}
            </Box>
          </Typography>
          <Field
            className="text-lowercase custom-input-field"
            name="email"
            as={TextField}
            variant="outlined"
            fullWidth
            defaultValue=""
            size="small"
            id="email"
            autoComplete="email"
            InputProps={{
              readOnly: guestCheckout ? false : true,
              endAdornment: (
                <InputAdornment position="end">
                  <Tooltip title={t('fields:helpIconEmailAddress')} placement="top">
                    <HelpCircle className="help-icon" />
                  </Tooltip>
                </InputAdornment>
              ),
            }}
          />
          <ErrorMessage name="email">
            {(msg) => <span className="error">{t(msg, { field: t('fields:emailAddress') })}</span>}
          </ErrorMessage>
        </Box>
      </Grid>
      {guestCheckout && (
        <Grid item xs={12} sm={6} md={6} lg={6}>
          <Typography component="p" variant="body2" color="textPrimary" gutterBottom>
            <Box component="span" fontWeight="500">
              {t('fields:gender')}
            </Box>
            {!guestCheckout && (
              <Box component="span" className="optional">
                ({t('fields:optional')})
              </Box>
            )}
          </Typography>
          <Field
            className={classes.selectIcon + ' custom-input-field'}
            name="gender"
            as={TextField}
            variant="outlined"
            fullWidth
            size="small"
            id="gender"
            pr={0}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Tooltip title={t('fields:helpIconGender')} placement="top">
                    <HelpCircle className="help-icon" />
                  </Tooltip>
                </InputAdornment>
              ),
            }}
            label={
              <span style={visuallyHidden}>
                ({t('fields:gender')}) ({t('fields:mandatory')}) ({t('fields:helpIconGender')})
              </span>
            }
            select
          >
            <MenuItem key="none" value="none">
              {t('none')}
            </MenuItem>
            {(metadata?.school_gender || []).map((gender) => (
              <MenuItem key={gender} value={gender}>
                {gender}
              </MenuItem>
            ))}
          </Field>
          <ErrorMessage name="gender">
            {(msg) => <span className="error">{t(msg, { field: t('fields:gender') })}</span>}
          </ErrorMessage>
        </Grid>
      )}
      <Grid item xs={12} sm={6}>
        <Box>
          <Typography component="p" variant="body2" color="textPrimary" gutterBottom>
            <Box component="span" fontWeight="500">
              {t('fields:country')}
            </Box>
            <Box component="span" className="mandatory">
              ({t('fields:mandatory')})
            </Box>
          </Typography>
          <Field
            id="address.adr_country_iso"
            className={classes.selectIcon + ' custom-input-field'}
            name="address.adr_country_iso"
            value={values?.address?.adr_country_iso}
            onChange={(e) => {
              const country =
                schooolCountries.find((country) => country.iso === e.target.value) || {}
              setFieldValue('address.adr_state_iso', '')
              setFieldValue('address.adr_state_name', '')
              setFieldValue('address.adr_country_iso', e.target.value)
              setFieldValue('address.adr_country_name', country.name)
            }}
            as={TextField}
            variant="outlined"
            fullWidth
            size="small"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Tooltip title={t('fields:helpIconCountry')} placement="top">
                    <HelpCircle className="help-icon" />
                  </Tooltip>
                </InputAdornment>
              ),
            }}
            select
          >
            {schooolCountries.map((country) => (
              <MenuItem key={country.iso} value={country.iso}>
                {country.name}
              </MenuItem>
            ))}
          </Field>
          <ErrorMessage name="address.adr_country_iso">
            {(msg) => <span className="error">{t(msg, { field: t('fields:country') })}</span>}
          </ErrorMessage>
        </Box>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Box>
          <Typography component="p" variant="body2" color="textPrimary" gutterBottom>
            <Box component="span" fontWeight="500">
              {t('fields:state')}
            </Box>
            <Box component="span" className="mandatory">
              ({t('fields:mandatory')})
            </Box>
          </Typography>
          {!isEmpty(states) || !values?.address?.adr_country_iso ? (
            <Field
              className={classes.selectIcon + ' custom-input-field'}
              name="address.adr_state_iso"
              as={TextField}
              value={values?.address?.adr_state_iso}
              onChange={(e) => {
                const state = states.find((state) => state.isoCode === e.target.value) || {}
                setFieldValue('address.adr_state_iso', e.target.value)
                setFieldValue('address.adr_state_name', state.name)
              }}
              variant="outlined"
              fullWidth
              size="small"
              id="address.adr_state_iso"
              pr={0}
              InputProps={{
                // <-- This is where the toggle button is added.
                endAdornment: (
                  <InputAdornment position="end">
                    <Tooltip title={t('fields:helpIconState')} placement="top">
                      <HelpCircle className="help-icon" />
                    </Tooltip>
                  </InputAdornment>
                ),
              }}
              select
            >
              {states.map((state) => (
                <MenuItem key={state.isoCode} value={state.isoCode}>
                  {state.name}
                </MenuItem>
              ))}
            </Field>
          ) : (
            <Field
              className="custom-input-field"
              name="address.adr_state_iso"
              as={TextField}
              variant="outlined"
              fullWidth
              size="small"
              id="address.adr_state_iso"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Tooltip title={t('fields:helpIconState')} placement="top">
                      <HelpCircle className="help-icon" />
                    </Tooltip>
                  </InputAdornment>
                ),
              }}
            />
          )}
          <ErrorMessage name="address.adr_state_iso">
            {(msg) => <span className="error">{t(msg, { field: t('fields:state') })}</span>}
          </ErrorMessage>
        </Box>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Box>
          <Typography component="p" variant="body2" color="textPrimary" gutterBottom>
            <Box component="span" fontWeight="500">
              {t('fields:city')}
            </Box>
            <Box component="span" className="mandatory">
              ({t('fields:mandatory')})
            </Box>
          </Typography>
          <Field
            className="custom-input-field"
            name="address.adr_city"
            as={TextField}
            variant="outlined"
            fullWidth
            size="small"
            id="address.adr_city"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Tooltip title={t('fields:helpIconCity')} placement="top">
                    <HelpCircle className="help-icon" />
                  </Tooltip>
                </InputAdornment>
              ),
            }}
          />
          <ErrorMessage name="address.adr_city">
            {(msg) => <span className="error">{t(msg, { field: t('fields:city') })}</span>}
          </ErrorMessage>
        </Box>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Box>
          <Typography component="p" variant="body2" color="textPrimary" gutterBottom>
            <Box component="span" fontWeight="500">
              {t('fields:postalCodeZip')}
            </Box>
            <Box component="span" className="mandatory">
              ({t('fields:mandatory')})
            </Box>
          </Typography>
          <Field
            className="custom-input-field"
            name="address.adr_zipcode"
            as={TextField}
            variant="outlined"
            fullWidth
            size="small"
            id="address.adr_zipcode"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Tooltip title={t('fields:helpIconPostalCodeZip')} placement="top">
                    <HelpCircle className="help-icon" />
                  </Tooltip>
                </InputAdornment>
              ),
            }}
          />
          <ErrorMessage name="address.adr_zipcode">
            {(msg) => <span className="error">{t(msg, { field: t('fields:postalCodeZip') })}</span>}
          </ErrorMessage>
        </Box>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Box>
          <Typography component="p" variant="body2" color="textPrimary" gutterBottom>
            <Box component="span" fontWeight="500">
              {t('fields:addressLine1')}
            </Box>
            <Box component="span" className="mandatory">
              ({t('fields:mandatory')})
            </Box>
          </Typography>
          <Field
            className="custom-input-field"
            name="address.adr_address1"
            as={TextField}
            variant="outlined"
            fullWidth
            size="small"
            id="address.adr_address1"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Tooltip title={t('fields:helpIconAddressLine1')} placement="top">
                    <HelpCircle className="help-icon" />
                  </Tooltip>
                </InputAdornment>
              ),
            }}
          />
          <ErrorMessage name="address.adr_address1">
            {(msg) => <span className="error">{t(msg, { field: t('fields:addressLine1') })}</span>}
          </ErrorMessage>
        </Box>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Box>
          <Typography component="p" variant="body2" color="textPrimary" gutterBottom>
            <Box component="span" fontWeight="500">
              {t('fields:addressLine2')}
            </Box>
            <Box component="span" className="optional">
              ({t('fields:optional')})
            </Box>
          </Typography>
          <Field
            className="custom-input-field"
            name="address.adr_address2"
            as={TextField}
            variant="outlined"
            fullWidth
            size="small"
            id="address.adr_address2"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Tooltip title={t('fields:helpIconAddressLine2')} placement="top">
                    <HelpCircle className="help-icon" />
                  </Tooltip>
                </InputAdornment>
              ),
            }}
          />
          <ErrorMessage name="address.adr_address2">
            {(msg) => <span className="error">{t(msg, { field: t('fields:addressLine2') })}</span>}
          </ErrorMessage>
        </Box>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Box className="guest-phonenumber">
          <Typography component="p" variant="body2" color="textPrimary" gutterBottom>
            <Box component="span" fontWeight="500">
              {t('fields:cellNumber')}
            </Box>
            {!guestCheckout && (
              <Box component="span" className="optional">
                ({t('fields:optional')})
              </Box>
            )}
          </Typography>
          <PhoneInput334
            id="address.adr_mobile"
            name="address.adr_mobile"
            prefixName="address.adr_mobile_prefix"
            countries={masterData?.countries}
            phonePrefix={values?.address?.adr_mobile_prefix}
            setFieldValue={setFieldValue}
            tooltipTitle={'fields:helpIconHomePhoneNumber'}
            mask={false}
          />
          <ErrorMessage name="address.adr_mobile">
            {(msg) => <span className="error">{t(msg, { field: t('fields:cellNumber') })}</span>}
          </ErrorMessage>
        </Box>
      </Grid>
      {guestCheckout && (
        <>
          <Grid item xs={12}>
            <Typography component="p" variant="body2" color="textPrimary" gutterBottom>
              <Box component="span" fontWeight="500">
                {t('fields:notes')}
              </Box>
              <Box component="span" className="optional">
                ({t('fields:optional')})
              </Box>
            </Typography>
            <Field
              className="custom-input-field"
              multiline
              rows={8}
              rowsMax={8}
              name="add_fee_guest_remark"
              as={TextField}
              variant="outlined"
              fullWidth
              size="small"
              id="add_fee_guest_remark"
              defaultValue=""
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Tooltip title={t('fields:guestFormNotesHelpText')} placement="top">
                      <HelpCircle className="help-icon" />
                    </Tooltip>
                  </InputAdornment>
                ),
              }}
              label={
                <span style={visuallyHidden}>
                  ({t('fields:notes')}) ({t('fields:required')}) (
                  {t('fields:guestFormNotesHelpText')})
                </span>
              }
            />
            <ErrorMessage name="add_fee_guest_remark">
              {(msg) => (
                <span className="error" tabIndex={0}>
                  {t(msg, { field: t('fields:notes') })}
                </span>
              )}
            </ErrorMessage>
          </Grid>
        </>
      )}
    </>
  )
}
PersonalInfoForm.propTypes = {
  masterData: PropTypes.object,
  schooolCountries: PropTypes.array,
  states: PropTypes.array,
  values: PropTypes.object,
  setFieldValue: PropTypes.func,
  birthDateVerification: PropTypes.func,
  birthDateErr: PropTypes.any,
  setBirthDateErr: PropTypes.func,
  guestCheckout: PropTypes.bool,
  metadata: PropTypes.object,
}
PersonalInfoForm.defaultProps = {
  masterData: {},
  schooolCountries: [],
  states: [],
  values: {},
  setFieldValue: noop,
  birthDateVerification: noop,
  birthDateErr: null,
  setBirthDateErr: noop,
  guestCheckout: false,
  metadata: {},
}

export default PersonalInfoForm
